/**
 * useHierarchicalTasks Hook
 * Groups flat task list into hierarchical structure with parent/child relationships
 */

import { useMemo } from 'react';
import { sortTasksByPriority, isRecoveryMode, getFoundationTasks } from '../utils/taskUtils';

export function useHierarchicalTasks(tasks = []) {
  return useMemo(() => {
    if (!tasks || tasks.length === 0) {
      return {
        parentTasks: [],
        taskSubtasksMap: {},
        foundationTasks: [],
        isRecovery: false,
        allTasks: []
      };
    }

    // Separate parent tasks from subtasks
    const parentTasks = tasks.filter(task => !task.is_subtask);
    const subtasks = tasks.filter(task => task.is_subtask);

    // Build map of parent task ID to its subtasks
    const taskSubtasksMap = {};

    parentTasks.forEach(parent => {
      const childTasks = subtasks.filter(
        sub => sub.parent_task_id === parent.id
      );
      taskSubtasksMap[parent.id] = childTasks;
    });

    // Sort parent tasks by priority
    const sortedParents = sortTasksByPriority(parentTasks, taskSubtasksMap);

    // Get foundation tasks (high unlock count, incomplete)
    const foundationTasks = getFoundationTasks(sortedParents);

    // Detect recovery mode
    const isRecovery = isRecoveryMode(sortedParents);

    return {
      parentTasks: sortedParents,
      taskSubtasksMap,
      foundationTasks,
      isRecovery,
      allTasks: tasks
    };
  }, [tasks]);
}
